"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useTranslations } from "next-intl";
import Button from "@/app/components/UI/Button";
import IInput from "@/app/components/Common/Input";
import TwoFactorCodeField from "@/app/components/Dashboard/Security/TwoFactorAuthentication/v3/TwoFactorCodeField";
import { TWO_FACTOR_ERROR_KEYS } from "@/app/apiServices/security/helpers";
import { PasswordIcon, ShowPasswordIcon } from "@/app/components/UI/Icons";
import maskPhoneNumber from "@/app/utils/maskPhoneNumber";
import type { AuthenticatorRecoveryFormProps } from "@/app/components/Dashboard/Security/TwoFactorAuthentication/v3/authenticatorRecoveryForm.interface";

/**
 * Forgot Authenticator during login (PRD 8, Figma "No access to GA"):
 * SMS OTP first; the password step is only shown after the OTP was accepted.
 */
export default function AuthenticatorRecoveryForm(props) {
  const $ = _c(39);
  const t = useTranslations();
  const [passwordType, setPasswordType] = useState("password");
  const isOtp = props.phase === "otp";
  let t0;
  if ($[0] !== t) {
    t0 = t("security.TFA_RECOVERY_TITLE");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className="text-base font-bold md:text-2xl">{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isOtp || $[5] !== props.mobile || $[6] !== t) {
    t2 = isOtp ? t("security.TFA_RECOVERY_OTP_DESC", {
      mobile: maskPhoneNumber(props.mobile)
    }) : t("security.TFA_RECOVERY_PASSWORD_DESC");
    $[4] = isOtp;
    $[5] = props.mobile;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <p className="mt-4 text-sm text-charcoal-600">{t2}</p>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isOtp || $[11] !== passwordType || $[12] !== props || $[13] !== t) {
    t4 = isOtp ? <TwoFactorCodeField label={t("security.TFA_STEP_CODE")} value={props.code} onChange={props.onCodeChange} errorKind={props.errorKind} expiresAt={props.expiresAt} onResend={props.onResend} /> : <form onSubmit={event => {
      event.preventDefault();
      props.onSubmitPassword();
    }}><div className="relative"><IInput inputId="recovery-password" label={t("security.PASSWORD")} type={passwordType} value={props.password} onChange={event_0 => props.onPasswordChange(event_0.target.value)} autoFocus={true} helper={props.errorKind ? t("security.TFA_RECOVERY_PASSWORD_WRONG") : ""} helperClass="text-rojo-400 text-xs" style={props.errorKind ? "secondaryOutlineError" : "secondaryOutline"} /><div className="absolute end-2 top-10 cursor-pointer" onClick={() => setPasswordType(passwordType === "password" ? "text" : "password")}>{passwordType === "password" ? <PasswordIcon className="h-6 w-6" /> : <ShowPasswordIcon className="h-6 w-6" />}</div></div></form>;
    $[10] = isOtp;
    $[11] = passwordType;
    $[12] = props;
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = props.onCancel;
  const t6 = props.isSubmitting;
  let t7;
  if ($[15] !== t) {
    t7 = t("general.CANCEL");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== props.isSubmitting || $[18] !== props.onCancel || $[19] !== t7) {
    t8 = <Button variant="outline" color="primary" onClick={t5} disabled={t6}>{t7}</Button>;
    $[17] = props.isSubmitting;
    $[18] = props.onCancel;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = isOtp ? props.code.length !== 6 : !props.password;
  const t10 = isOtp ? props.onSubmitOtp : props.onSubmitPassword;
  let t11;
  if ($[21] !== isOtp || $[22] !== t) {
    t11 = isOtp ? t("security.TFA_NEXT") : t("security.TFA_RECOVERY_SUBMIT");
    $[21] = isOtp;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== props.isSubmitting || $[25] !== t10 || $[26] !== t11 || $[27] !== t9) {
    t12 = <Button className="flex-1" loading={props.isSubmitting} disabled={t9} onClick={t10}>{t11}</Button>;
    $[24] = props.isSubmitting;
    $[25] = t10;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t8) {
    t13 = <div className="mt-6 flex gap-x-3">{t8}{t12}</div>;
    $[29] = t12;
    $[30] = t8;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t4) {
    t14 = <div className="my-10">{t4}{t13}</div>;
    $[32] = t13;
    $[33] = t4;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t1 || $[36] !== t14 || $[37] !== t3) {
    t15 = <div className="mt-6">{t1}{t3}{t14}</div>;
    $[35] = t1;
    $[36] = t14;
    $[37] = t3;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}